import React from "react";

const Loading = () => {
  return (
    <div>
      <button className="btn loading">Please Wait</button>
    </div>
  );
};

export default Loading;
